import MotivosView from "../../components/rh/MotivosView";

export default function MotivosRh() {
  return <MotivosView />;
}
